module.exports = __webpack_public_path__ + "static/img/title-banner1-type1.c201fd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/3/title-banner1-type1.png
// module id = FFLg
// module chunks = 1